import { Popup } from "semantic-ui-react";
import moment from "moment";
import { convertToLocalDateTime } from "components/helpers";

const RuvixxDate = ({ date, isAbsoluteDateEnabled }) => {
  const localDate = convertToLocalDateTime(date);
  const relativeDate = moment().to(localDate);
  const absoluteDate = localDate.format("MMMM Do YYYY, h:mm:ss a z");

  return isAbsoluteDateEnabled ? (
    <>{absoluteDate}</>
  ) : (
    <Popup
      trigger={<div>{relativeDate}</div>}
      content={<div>{absoluteDate}</div>}
    ></Popup>
  );
};

export default RuvixxDate;
